export default {
  namespaced: true,
  state: {
    postPoll: {
      show: false,
    },
  },
  mutations: {
    togglePollModal(state, obj) {
      state.postPoll.show = obj.show ? obj.show : false;
    },
  },
};
